import { render, staticRenderFns } from "./RoundtableSeating.vue?vue&type=template&id=11e85f5c&"
import script from "./RoundtableSeating.vue?vue&type=script&lang=js&"
export * from "./RoundtableSeating.vue?vue&type=script&lang=js&"
import style0 from "./RoundtableSeating.vue?vue&type=style&index=0&id=11e85f5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports